import { gql } from 'src/__generated__';

gql(`
  fragment RefreshedQualifications on Candidate {
    _id
    qualifications(
      includeVerified: true
      status: confirmed
      zone: $zone
      languageCode: $languageCode
    ) {
      ...qualification
    }
  }
`);

export const DELETE_MUTATION = gql(`
  mutation DeleteQualification(
    $id: UUID!
    $zone: Zone!
    $languageCode: LanguageCodeIso!
    ) {
    deleteQualification(input: { id: $id }) {
      viewer {
        ...RefreshedQualifications
      }
    }
  }
`);

export const REJECT_MUTATION = gql(`
  mutation RejectUnconfirmedData(
    $id: UUID!
    $zone: Zone!
    $languageCode: LanguageCodeIso!
    $contextId: String!
    ) {
    rejectUnconfirmedData(input: { id: $id, dataType: Education }) {
      viewer {
        ...RefreshedQualifications
        unconfirmedDataForContext(
          contextId: $contextId
          contextType: Application
          languageCode: $languageCode
        ) {
          ... on UnconfirmedDataCompleted {
            roles {
              ...unconfirmedRole
            }
          }
        }
      }
    }
  }
`);

export const CONFIRM_MUTATION = gql(`
  mutation ConfirmQualification(
    $qualification: ConfirmQualificationInput!
    $zone: Zone!
    $languageCode: LanguageCodeIso!
    $contextId: String!
    ) {
    confirmQualification(input: $qualification) {
      viewer {
        ...RefreshedQualifications
        unconfirmedDataForContext(
          contextId: $contextId
          contextType: Application
          languageCode: $languageCode
        ) {
          ... on UnconfirmedDataCompleted {
            roles {
              ...unconfirmedRole
            }
          }
        }
      }
    }
  }
`);

export const UPDATE_MUTATION = gql(`
  mutation UpdateQualification(
    $input: UpdateQualificationInput!
    $zone: Zone!
    $languageCode: LanguageCodeIso!
  ) {
    updateQualification(input: $input) {
      viewer {
        ...RefreshedQualifications
      }
    }
  }
`);
